import { type Lang, isLang } from "@majourneys/shared";
type SupportedLocale = Lang;

const MOROCCO_BY_LOCALE: Record<SupportedLocale, string> = {
  en: "Morocco",
  fr: "Maroc",
  ar: "المغرب",
  es: "Marruecos",
  it: "Marocco",
  de: "Marokko",
  nl: "Marokko",
};

export function normalizeLocale(locale?: string | null): SupportedLocale {
  const base = locale?.split("-")[0];
  return isLang(base) ? base : "en";
}

export function getMoroccoName(locale?: string | null): string {
  return MOROCCO_BY_LOCALE[normalizeLocale(locale)];
}

export function formatMoroccoLocation(cityName: string | null | undefined, locale?: string | null): string {
  const countryName = getMoroccoName(locale);
  // "مراكش، المغرب": Arabic takes its own comma (2026-11-04, page titles
  // read "مراكش, المغرب").
  const comma = (locale ?? "").toLowerCase().startsWith("ar") ? "، " : ", ";
  return cityName ? `${cityName}${comma}${countryName}` : countryName;
}
